import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AgxTypography } from '@urbanx/agx.ui-components2';
import { AuthContext } from '@urbanx/agx.auth.client';
import {
  useGetListingAgreementConfiguration,
  useUpdateListingAgreementConfiguration,
  useInvalidateUseGetListingAgreementConfiguration,
} from '@urbanx/agx.agencies.client';
import { MenuTitles, SettingsMenu } from 'constants/menu';
import { ContentLayout, PageLayout } from 'layout';
import { useSelectedAgency } from 'hooks';
import LoadingState from 'components/loadingState/LoadingState';
import { ListingAgreementEditor } from './ListingAgreementEditor';

const ListingAgreementView = () => {
  const { userAccount } = useContext(AuthContext);
  const { agencyId = '' } = useParams();
  const { agency } = useSelectedAgency();
  const [activeMenu, setActiveMenu] = useState<MenuTitles | undefined>(
    MenuTitles.LISTING_AGREEMENT
  );
  const { data, isPending, isError } = useGetListingAgreementConfiguration(agencyId, !!agencyId);
  const { updateListingAgreementConfiguration } = useUpdateListingAgreementConfiguration();
  const invalidate = useInvalidateUseGetListingAgreementConfiguration();

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={MenuTitles.SETTINGS}
    >
      <ContentLayout
        hasSecondaryMenu
        secondaryActiveMenu={MenuTitles.SETTINGS}
        tertiaryMenu={SettingsMenu}
        tertiaryActiveMenu={activeMenu}
      >
        {isPending && <LoadingState />}
        {isError && (
          <AgxTypography type="form_error" role="alert">
            Unable to load listing agreement settings. Reload the page to try again.
          </AgxTypography>
        )}
        {data && (
          <ListingAgreementEditor
            key={agencyId}
            configuration={data}
            onBack={() => setActiveMenu(undefined)}
            licences={agency?.companyDetails?.licences}
            onSave={async (configuration) => {
              const saved = await updateListingAgreementConfiguration({
                agencyId,
                body: configuration,
              });
              if (!saved)
                throw new Error('No listing agreement settings were returned after saving.');
              await invalidate(agencyId);
              return saved;
            }}
          />
        )}
      </ContentLayout>
    </PageLayout>
  );
};
export default ListingAgreementView;
